export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              投稿、合作、意见反馈，我们期待你的声音
            </p>
          </div>

          <div className="rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              <div className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900">投稿邮箱</h3>
                <p className="text-xs text-foreground-500">投稿&合作</p>
                <span className="text-sm text-primary-600 font-medium">submit@fanqiecomic.com</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900">官方微信</h3>
                <p className="text-xs text-foreground-500">获取最新更新资讯</p>
                <span className="text-sm text-accent-600 font-medium">fanqiecomic</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                  <i className="ri-question-answer-line text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900">意见反馈</h3>
                <p className="text-xs text-foreground-500">帮助我们变得更好</p>
                <span className="text-sm text-secondary-600 font-medium">feedback@fanqiecomic.com</span>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-background-200/70">
              <p className="text-xs text-foreground-400 text-center leading-relaxed">
                我们每天处理大量读者来稿与反馈，通常会在 24 小时内回复。
                欢迎漫画作者、翻译组、合作平台与我们联系，共同打造更好的追漫体验。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}